export function StatCard({ icon: Icon, label, value, hint, accent = false, index = 0 }) {
  return (
    <div
      className="fade-up rounded-lg border border-border bg-card p-5 hover:shadow-md transition-shadow duration-200"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`stat-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.14em] font-semibold text-muted-foreground">{label}</span>
        {Icon && (
          <span className={`h-8 w-8 rounded-md flex items-center justify-center ${accent ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground"}`}>
            <Icon size={17} weight="fill" />
          </span>
        )}
      </div>
      <div className="mt-3 font-heading text-[28px] leading-none font-semibold tracking-tight">{value}</div>
      {hint && <div className="mt-2 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
